<template>
  <d-container fluid class="px-3 main-content-container">
    <h6>Adicione as fotos:</h6>
    <p>
      Adicione imagens que mostrem a fachada da loja, fotos mais abertas que
      mostrem as áreas do showroom, fotos das paginações em showroom com
      produtos Castelatto, tente também inserir fotos dos expositores de sample,
      amostras e peças, quanto mais imagens melhor. Ajude-nos a melhorar nossa
      exposição nos parceiros!
    </p>
    <div class="imagens-container">
      <gallery-images :model.sync="images" @uploadFiles="uploadFiles" :deleteEvent="DELETE_FILES"/>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <p class="mb-0">({{total}}/30)</p>
      <d-button type="button" size="sm" @click="submitFiles">Enviar</d-button>
    </div>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteImage"
      :title="title"
      modal-name="confirm_file"
      message="Tem certeza que deseja excluir esta imagem?"/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import GalleryImages from '_shared/GalleryImages.vue';
import ResellerService from '_services/rest/modules/reseller';
import { mapActions } from 'vuex';

const DELETE_FILES = 'DELETE:fileReseller';

export default {
  name: 'Image-tab',
  data() {
    return {
      DELETE_FILES,
      total: 0,
      title: 'Confirmação para deletar imagem',
      fileToDelete: null,
      resellerId: this.$route.params.resellerId,
      images: [],
    };
  },
  computed: {},
  components: {
    GalleryImages,
    ConfirmationModal,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    close() {
      this.setToggle({ type: 'confirm_file', bool: false });
    },
    getImagesList() {
      ResellerService.getImagesList(this.resellerId)
        .then(response => {
          this.images = response.list;
          this.total = response.total_items;
        });
    },
    uploadFiles(values) {
      const total = this.total + values.length;
      if (total > 30) {
        // eslint-disable-next-line
        alert(`Voce esta com ${total} imagens no total. A quantidade máxima são 30 imagens`);
        return false;
      }
      this.images = this.images.concat(values);
      return true;
    },
    deleteImage() {
      ResellerService.deleteImages(this.resellerId, this.fileToDelete.id)
        .then(() => {
          this.close();
          this.getImagesList();
        });
    },
    submitFiles() {
      if (this.total > 30) {
        // eslint-disable-next-line
        alert('Passou a quantidade máxima de 30 imagens');
        return false;
      }
      return ResellerService.saveImages(this.resellerId, { images: this.images })
        .then(() => {
          Events.$emit('uploaded:files');
          this.getImagesList();
        });
    },
  },
  mounted() {
    this.getImagesList();
    Events.$on(DELETE_FILES, ({ object }) => {
      this.fileToDelete = object;
      this.setToggle({ type: 'confirm_file', bool: true });
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.add-image {
  border: 1px solid $border-color;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
</style>
